import Swiper, { Navigation, Autoplay } from 'swiper';
import selectors from '../globals/selectors';

export default () =>
	new Swiper(selectors.promoCarousel.swiper, {
		slidesPerView: 1,
		slidesPerGroup: 1,
		loop: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		modules: [Navigation, Autoplay],
		navigation: {
			nextEl: selectors.promoCarousel.navNext,
			prevEl: selectors.promoCarousel.navPrev,
		},
	});
